// extracted by mini-css-extract-plugin
export default {"modal":"ModalWrap_modal__o-syc","active":"ModalWrap_active__ZLkuL","content":"ModalWrap_content__jS1Jf","close":"ModalWrap_close__6kGnw"};